module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.size_,
    style: (_vm.styleObject)
  }, [_vm._t("media", [_c('img', {
    staticClass: "card-slot",
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2e4a69b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card.vue
// module id = 503
// module chunks = 1